export enum PurchaseBlockerModalType {
  ZOHO = 'zoho',
  LEADSQUARED = 'leadsquared',
  SALESFORCE = 'salesforce',
  WOOCOMMERCE = 'woocommerce',
  ACTIVITY_LOGS = 'activity-logs',
  SLA = 'sla',
  SSO = 'sso',
}
